module.exports = __webpack_public_path__ + "img/p6-p1-chuan.411c2891.png";